<template>
<!--
  <b-overlay :show="updateExists" variant="primary" opacity="0.92" z-index="2999"> -->
      <b-overlay :show="isSiteDown" variant="secondary" opacity="0.87" z-index="2899">
        <router-view />
        <template #overlay>
          <div class="text-center card p-3">
            <div class="p-3">
              <b-spinner  style="width: 3rem; height: 3rem;" class="mb-3" label="Loading..."></b-spinner>
              <h2 id="sitedown-label" class="mb-2">Maintenance is currently running!</h2>
        <h4 id="sitedown-label" class="mb-1">Looks like Connect is currently down, but don't worry, we should be back in a few seconds!</h4>
            </div>
          </div>
        </template>
      </b-overlay>
<!--
    <template #overlay>
      <div class="text-center card p-3">
        <div class="p-3">

          <b-icon icon="stopwatch" size="lg" font-scale="3" animation="cylon"></b-icon>
          <h3 id="cancel-label" class="mb-2">An update is available!</h3>
            <b-button
              variant="primary"
              class="btn-block"
              size="lg"
              aria-describedby="refresh-label"
              @click="refreshApp()"
            >
            Refresh!
            </b-button>
            <b-button
              variant="outline-secondary"
              size="lg"
              class="ml-1 mt-1 btn-block"
              aria-describedby="refresh-label"
              @click="updateExists = false"
            >
              Update Later
            </b-button>
        </div>
      </div>
    </template>
  </b-overlay> -->

</template>

<script>
export default {
  name: 'App',
  meta: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'LaCore',
    // all titles will be injected into this template
    titleTemplate: '%s | Connect'
  },
  data() {
    return {
      isSiteDown: false,
      //refreshing: false,
      registration: null,
      canDoRefresh: false,
      updateExists: false,
    }
  },
  mounted() {
    this.$store.commit('setAppUrl', process.env.VUE_APP_API_URL);
    this.$store.commit('setVersion', process.env.VUE_APP_VERSION);
  },
  created() {
    //document.addEventListener('swSiteDown', this.siteWentDown)
    document.addEventListener('swSiteUp', this.siteWentUp)
    document.addEventListener('swActivated', this.swWasActivated, { once: true })
    document.addEventListener('swUpdated', this.updateAvailable, { once: true })
  },
  methods: {
    siteWentUp() {
      this.isSiteDown = false
    },
    // siteWentDown() {
    //   this.isSiteDown = true
    // },
    updateAvailable(event) {
      this.registration = event.detail
      this.updateExists = true
      if(this.registration && this.registration.waiting)
        this.registration.waiting.postMessage({ type: 'skipWaiting' });
      this.messageAboutUpdate();
    },
    messageAboutUpdate() {
      this.canDoRefresh = true;
      this.$swal({
        title: 'New Version Detected!',
        text: "Ready to update to latest version of Connect?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes!',
        cancelButtonText: 'Later'
      }).then(result => {
        if (result.value) {
            window.location.reload();
            this.updateExists = false;
        }
      });
    }
  }
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import '~@coreui/icons/css/coreui-icons.min.css';
/* Import Simple Line Icons Set */
$simple-line-font-path: '~simple-line-icons/fonts/';
@import '~simple-line-icons/scss/simple-line-icons.scss';
/* Import Bootstrap Vue Styles */
@import '~bootstrap-vue/dist/bootstrap-vue.css';
// Import Main styles for this application
@import 'assets/scss/style';

.badge {
  &.badge-green {
    background-color: #28a745 !important;
  }
}
.bigmultiple {
  min-height: 400px;
}
.modal {
  &.huge-modal {
    max-width: 1100px;
    .modal-dialog {
      max-width: 1100px;
    }
  }
}
.content img {
  max-width: 100%;
}
.group-filtertop {
  min-width: 300px;
  max-width: 100%;
}

.table-responsive,
.table-responsive-sm {
  table {
    width: auto;
    min-width: 100%;
  }
}
.notReady {
  opacity: 0.3;
  * {
    pointer-events: none;
  }
}

.table .td {
  min-width: 140px;
}
.popover {
  max-width: 400px;
}
.popover .popover-body {
  max-height: 500px;
  overflow: auto;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #f8f9fa;
  border-color: #f8f9fa;
  opacity: 0.65;
  cursor: not-allowed;
}
.w-shadow {
  box-shadow: 0 1px 1px 0 rgba(60, 75, 100, 0.14),
    0 2px 1px -1px rgba(60, 75, 100, 0.12), 0 1px 3px 0 rgba(60, 75, 100, 0.2);
}
.list-group.shadow.vbt-autcomplete-list .vbst-item {
    padding: 3px 6px;
    background: white;
    &.active {
      background: #343a40;
      color: #fff;
    }
}
</style>
